let digitTest = /^\d+$/,
	keyBreaker = /([^[\]]+)|(\[\])/g,
	plus = /\+/g,
	paramTest = /([^?#]*)(#.*)?$/

export const param = a => {
	const s = [],
		brack = /\[\]$/,
		isArray = function (obj) {
			return Object.prototype.toString.call(obj) === '[object Array]'
		},
		add = function (k, v) {
			v =
				typeof v === 'function'
					? v()
					: v === null
						? ''
						: v === undefined
							? ''
							: v
			s[s.length] = encodeURIComponent(k) + '=' + encodeURIComponent(v)
		},
		buildParams = function (prefix, obj) {
			let i, len, key

			if (prefix) {
				if (isArray(obj)) {
					for (i = 0, len = obj.length; i < len; i++) {
						if (brack.test(prefix)) {
							add(prefix, obj[i])
						} else {
							buildParams(
								prefix +
									'[' +
									(typeof obj[i] === 'object' ? i : '') +
									']',
								obj[i]
							)
						}
					}
				} else if (obj && String(obj) === '[object Object]') {
					for (key in obj) {
						buildParams(prefix + '[' + key + ']', obj[key])
					}
				} else {
					add(prefix, obj)
				}
			} else if (isArray(obj)) {
				for (i = 0, len = obj.length; i < len; i++) {
					add(obj[i].name, obj[i].value)
				}
			} else {
				for (key in obj) {
					buildParams(key, obj[key])
				}
			}
			return s
		}

	return buildParams('', a).join('&').replace(/%2C/g, ',')
}

/*
 * @function deparam
 *
 * Takes a string of name value pairs and returns a Object literal that represents those params.
 *
 * Defaults to location.search if no argument is sent.
 *
 * Strips the leading question mark if it exists.
 *
 * @param {String} params a string like <code>"foo=bar&person[age]=3"</code>
 * @return {Object} A JavaScript Object that represents the params:
 *     {
 *       foo: "bar",
 *       person: {
 *         age: "3"
 *       }
 *     }
 */
export const deparam = (params = location.search) => {
	if (!params || !paramTest.test(params)) {
		return {}
	}

	// Strip leading question mark if it exists
	if (params[0] === '?') {
		params = params.substring(1)
	}

	let data = {},
		pairs = params.split('&'),
		current

	for (let i = 0; i < pairs.length; i++) {
		current = data
		let pair = pairs[i].split('=')

		// if we find foo=1+1=2
		if (pair.length !== 2) {
			pair = [pair[0], pair.slice(1).join('=')]
		}

		let key = decodeURIComponent(pair[0].replace(plus, ' ')),
			value = decodeURIComponent(pair[1].replace(plus, ' ')),
			parts = key.match(keyBreaker)

		for (let j = 0; j < parts.length - 1; j++) {
			let part = parts[j]
			if (!current[part]) {
				// if what we are pointing to looks like an array
				current[part] =
					digitTest.test(parts[j + 1]) || parts[j + 1] === '[]'
						? []
						: {}
			}
			current = current[part]
		}
		let lastPart = parts[parts.length - 1]
		if (lastPart === '[]') {
			current.push(value)
		} else {
			current[lastPart] = value
		}
	}
	return data
}
